<template>
    <div class="tablePmm">
		<complete-loading :pageloader_value="pageLoader" :type="'complete'" v-if="pageLoader && pageName != 'dashboard'"></complete-loading>
		<!--<div class="d-flex justify-content-between border-bottom pb-3 px-3 mb-2" v-if="pageName != 'dashboard'">
			<div></div>
			<filter-component :limitFilter="'disable'" :searchFilter="'disable'" :pageTitle="'close-trade'"></filter-component>
		</div>-->
		<table class="table pmmTable" v-if="lastSelectTradingAccount != '' && lastSelectTradingAccount[0].platform == 'MT4'">
            <thead>
                <tr>
                    

                    <!-- Login = login;
                    Order id= order; 
                    Symbol = symbol;
                    Volume= volume;
                    Open Price= open_price;
                    Open Time= open_time;
                    Commission=commission;
                    Type= cmd; 
                    SL = sl; 
                    TP = tp;
                    Close price= close_price; 
                    Close Time = close_time; 
                    Swap= swap
                    PNL= profit; 
                    Comment = comment;
                     -->
					<th>{{$t('login')}}</th>
                    <th>{{$t('order')}}</th>
                    <th>{{$t('symbol')}}</th>
                    <th>{{$t('volume')}}</th>
					<th>{{$t('openPrice')}}</th>
                    <th>{{$t('openTime')}}</th>
                    <th>{{$t('commision')}}</th>
                    <th>{{$t('type')}}</th>
                    <th>{{$t('SL')}}</th>
                    <th>{{$t('TP')}}</th>
                    <th>Close Price</th>
					<th>Close Time</th>
                    <th>{{$t('Swap')}}</th>
                    <th>{{$t('PNL')}}</th>
                     <th>{{$t('comment')}}</th>
                </tr>
            </thead>
            <tbody v-if="accountDetails != '' && 'history' in accountDetails && Object.keys(accountDetails.history).length >0 && accountDetails.history.csv_array.length > 0">
                <tr v-for="list in accountDetails.history.csv_array" >

                    <!-- 
                    0 login
                    1 order
                    2 symbol
                    6 volume
                    3 open_price
                    7 open_time
                    10 commission
                    12 cmd
                    13 sl
                    14 tp
                    4 close_price
                    8 close_time
                    15 swap
                    5 profit
                    9 comment
                    11 agent_commission
                    -->
                    <td>{{list[0]}} </td>
                    <td>{{list[1]}} </td>
                    <td>{{decodeURIComponent(list[2])}}</td>
                    <td >{{list[6]/100}}</td>
                    <td >{{list[3]}}</td>
                    <td>{{timeFunc(list[7])}}</td>
                    <td >{{list[10]}}</td>

                    <td v-if="list[12] == 0">{{$t('buy')}}</td>
                    <td v-if="list[12] == 1">{{$t('sell')}}</td>
                    <td v-if="list[12] == 6">{{$t('deposit')}}</td>

                    <!-- <td >{{list[12]}}</td> -->
                    <td >{{list[13]}}</td>
                    <td >{{list[14]}}</td>
                    <td >{{list[4]}}</td>
                    <td v-if="list[12] !== 6">{{timeFunc(list[8])}}</td>
                    <td v-else>-</td>
                    <td >{{list[15]}}</td>
                    <td >{{list[5]}}</td>
                    <td >{{decodeURIComponent(list[9])}}</td>
                </tr>
            </tbody>
			<tbody v-else>
				<tr>
					<td class="noRecordFound"  colspan="10"> 
						<img src="../../../../../static/fxView/images/search.svg" alt="no record found">
						<p>{{$t('thereIsNoRecord')}}</p>
					</td>
				</tr>
			</tbody>
            <!--<loader-component :pageloader_value="'false'" :type="'table'" :colspan="col_span1" :list="accountDetails" v-else></loader-component>-->
        </table>

        <table class="table pmmTable" v-if="lastSelectTradingAccount != '' && lastSelectTradingAccount[0].platform == 'MT5'">
            <thead>
                <tr>
                    <!-- Login = login;
                    deal id= deal; 
                    Symbol = symbol;
                    Type= cmd;
                    Volume= volume;
                    Open Time= done_time;
                    Price= price;
                    Commission=commission;
                    Swap= swap
                    PNL= profit; 
                    Comment = comment; -->

                    <th>{{$t('login')}}</th>
                    <th>{{$t('deal')}}</th>
                    <th>{{$t('symbol')}}</th>
                    <th>{{$t('type')}}</th>
                    <th>{{$t('Volume')}}</th>
                    <th>{{$t('openTime')}}</th>
                    <th>{{$t('price')}}</th>
                    <th>{{$t('commission')}}</th>
                    <th>{{$t('swap')}}</th>
                    <th>{{$t('pnl')}}</th>
                    <th>{{$t('comment')}}</th>
                </tr>
            </thead>
            <tbody v-if="accountDetails != '' && 'history' in accountDetails && Object.keys(accountDetails.history).length >0 && accountDetails.history.csv_array.length > 0">
                <tr v-for="list in accountDetails.history.csv_array">

                   <!--  login;order;symbol;activation_price;price_current;price_order;price_sl;price_tp;price_trigger;state;volume_initial;volume_current;time_setup;time_done;time_expiration;type;contract_size;digits;external_id;position_id;type_fill;type_time;rate_margin;comment;activation_mode -->

                    <td>{{list[0]}} </td>
                    <td>{{list[1]}}</td>
                    <td>{{decodeURIComponent(list[3])}}</td>

                    <td v-if="list[13] == 0">{{$t('buy')}}</td>
                    <td v-if="list[13] == 1">{{$t('sell')}}</td>
                    <td v-if="list[13] == 2">{{$t('deposit')}}</td>
                    <td>{{list[9]}}</td>
                    <td v-if="list[13] !== 2">{{timeFunc(list[12])}}</td>
                    <td v-else>-</td>
                    <td>{{list[4]}}</td>
                    <td>{{list[6]}}</td>
                    <td>{{list[24]}}</td>
                    <td>{{list[5]}}</td>
                    <td>{{decodeURIComponent(list[25])}}</td>
                    
                </tr>
            </tbody>
            <tbody v-else>
                <tr>
                    <td class="noRecordFound"  colspan="10"> 
                        <img src="../../../../../static/fxView/images/search.svg" alt="no record found">
                        <p>{{$t('thereIsNoRecord')}}</p>
                    </td>
                </tr>
            </tbody>
            <!--<loader-component :pageloader_value="'false'" :type="'table'" :colspan="col_span1" :list="accountDetails" v-else></loader-component>-->
        </table>
		<table class="table pmmTable" v-else-if="lastSelectTradingAccount != '' && lastSelectTradingAccount[0].platform == 'ACT'">
			<thead>
                <tr>
                    <th>{{$t('login')}}</th>
                    <th>{{$t('order')}}</th>
                    <th>{{$t('symbol')}}</th>
                    <th>{{$t('volume')}}</th>
                    <th>{{$t('openPrice')}}</th>
                    <th>{{$t('openTime')}}</th>
                    <th>Close Price</th>
                    <th>Close Time</th>
                    <th>{{$t('PNL')}}</th>
                     <th>{{$t('comment')}}</th>
                </tr>
            </thead>
            <!-- ACCOUNT_ID: "122"
            AMOUNT: "1379000"
            CLOSE_AMOUNT: "1379000"
            CLOSE_RATE: ".72064"
            CLOSE_TIME: "20200807071254"
            COND_TYPE: "C"
            INSTRUMENT: "301"
            INSTRUMENT_NAME: "AUDUSD."
            NET_PNL: "-688.37"
            OPEN_RATE: ".72005"
            OPEN_TIME: "20200807063553"
            TRADER: "T324582"
            TRADER_ID: "9598" -->
			<tbody v-if="accountDetails != '' && 'history' in accountDetails && accountDetails.history.length >0">
                <tr v-for="list in accountDetails.history">
                    <td>{{list.TRADER}}</td>
                    <td>{{list.TRADER_ID}}</td>
                    <td>{{list.INSTRUMENT_NAME}}</td>
                    <td>{{list.CLOSE_AMOUNT}}</td>
                    <td>{{list.OPEN_RATE}}</td>
                    <td>{{timeFunc(parseInt(list.OPEN_TIME/1000))}}</td>
                    <td>{{list.CLOSE_RATE}}</td>
                    <td>{{list.NET_PNL}}</td>
                    <td>-</td>
                </tr>
            </tbody>
            <tbody v-else>
                <tr>
                    <td class="noRecordFound"  colspan="10"> 
                        <img src="../../../../../static/fxView/images/search.svg" alt="no record found">
                        <p>{{$t('thereIsNoRecord')}}</p>
                    </td>
                </tr>
            </tbody>
            <!--<loader-component :pageloader_value="'false'" :type="'table'" :colspan="col_span1" :list="accountDetails" v-else></loader-component>-->
        </table>
    </div>
</template>
<script>
    import { fxViewMixins } from '@/plugins/fxView'
    import { Const }  from '@/plugins/fxView/provider/candle-history/lib/const.cls'
	import moment from 'moment'
    export default {
        name: 'Dashboard',
        mixins: [fxViewMixins],
		props:['pageName'],
        data() {
            return {col_span : 7 ,col_span1 : 13,fromDateField : '',toDateField : '',pageLoader : false}
        },
		methods:{
			listing(){
				let inputJson = {
					'globalParams' : {
						'from':this.fromDateField.toString() ,
						'to':this.toDateField.toString(),
						'act_account_id': this.lastSelectTradingAccount[0].act_account_id,
						'account_id' : this.lastSelectTradingAccount[0].account_id,  
						'demo_live' : this.lastSelectTradingAccount[0].demo_live , 
						'platform' : this.lastSelectTradingAccount[0].platform
					} ,'localParams' : {'parameter' : this }
				}
				this._runGetAccountHistory(inputJson)
			},
			timeFunc(getData){
				return moment.unix(getData).format("DD-MM-YYYY, h:mm:ss");
			}
		}
    }
</script>


// WEBPACK FOOTER //
// src/components/fxView/shared/tradingAccounts/close_trades_listing.vue